import React from "react";
import ReusableTable from "../../../Admin-Dashboard/@components/Table";
import Button from "../../../Admin-Dashboard/@common/Button";
import DynamicFilters from "../../../Admin-Dashboard/@components/DynamicFilters";
import AuditLogModal from "../../../Admin-Dashboard/@components/AuditLogModal";
import Sidebar from "../../components/Sidebar";
import useWpTemplate from "./view/useWpTemplate";
import BreadCrumb from "../../../Admin-Dashboard/@components/Breadcrumb";
const CommunicationTemplate = () => {
  const {
    columns,
    rows,
    handleNewEntry,
    handleViewEntry,
    page,
    onPageChange,
    metaInfo,
    filterStructure,
    onSetFilters,
    filters,
    onApplyFilters,
    onClear,
    onSortAction,
    onLogModalOpenClose,
    logModalOpen,
    logModalInfoProp,
  } = useWpTemplate();
  return (
    <div className="flex">
      <Sidebar
        active_link="/dashboard/user-notification/communication-template"
        type="data_collection"
        title="Dashboard"
      />
      <div className="pl-8 w-[75%]  dashboard-image mt-20">
        <div className="header-container ">
          <div>
            <BreadCrumb
              breadCrumbArray={[
                {
                  label: "Dashboard",
                  link: "/dashboard",
                },
                { label: "Communication Templates", link: "" },
              ]}
            />{" "}
            <h1 className="title mt-4">Communication Templates</h1>
            <p className="subTitle">
              {metaInfo?.total ? metaInfo?.total : 0} Entries found
            </p>
          </div>
          <Button
            onClick={handleNewEntry}
            variant="contained"
          >
            + Create New Communication Template
          </Button>
        </div>
        <div className="flex flex-col">
          <DynamicFilters
            filterStructure={filterStructure}
            onSetFilters={onSetFilters}
            filterValues={filters}
            onApplyFilters={onApplyFilters}
          />
          <div className="my-4 flex gap-4 justify-end">
            <Button
              onClick={onApplyFilters}
              disabled={(() => {
                let { orderBy, orderType, ...newFilter } = filters;
                return Object.keys(newFilter).length === 0;
              })()}
              variant="contained"
            >
              Apply Filters
            </Button>
            <Button handleClick={onClear}>Clear</Button>
          </div>
        </div>
        <ReusableTable
          columns={columns}
          rows={rows}
          onRowClick={()=>{}}
          page={page}
          loading={false}
          onPageChange={onPageChange}
          totalCount={metaInfo?.lastPage}
          totalRows={metaInfo?.total}
          perPage={metaInfo?.perPage}
          orderBy={filters?.orderBy}
          orderType={filters?.orderType}
          createSortHandler={onSortAction}
        />
        <AuditLogModal
          handleClose={onLogModalOpenClose}
          isModel={logModalOpen}
          modalInfo={logModalInfoProp}
          onAuditAction={handleViewEntry}
        />
      </div>
    </div>
  );
};

export default CommunicationTemplate;
